module.exports = __webpack_public_path__ + "img/pause-yellow.70032ec5.svg";